import { store } from '@betacrew/jars-flux';
import { all, put, takeLatest } from 'redux-saga/effects';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { PAGE_STATE } from '../../constants/constants';
import { componentKey, setBulkAddressMatchModalOpen, setBulkInActivateModalOpen, setBulkReActivateModalOpen, setDeleteRecipientConfirmationModalOpen, setHighlightedRecipient, setIsUpdateEmailSuccess, setLoadingState, setPaginationState, setRecipientList, setSelectedRecipients, setShouldReloadPaginatedRecipientList, setSingleActivateReactivateModal } from "./RecipientListSlice"
import RecipientDataService from '../../../../services/RecipientDataService';
import General from "../../../../libs/utility/General";
import { RECIPIENT_LISTING_LOADING_STATES } from './constants';

export const { getPaginatedRecipientsList, deleteRecipient, bulkAddressMatch, downloadW8W9RequestPDF, bulkInactivate, bulkReactivate, blockTinRequest, unBlockTinRequest, updateRecipientEmail } = {

    getPaginatedRecipientsList: (payload) => {
        return {
            type: "GET_PAGINATED_RECIPIENTS_LIST",
            payload
        }
    },

    deleteRecipient: (payload) => {
        return {
            type: "DELETE_RECIPIENT",
            payload
        }
    },

    bulkAddressMatch: (payload) => {
        return {
            type: "BULK_ADDRESS_MATCH",
            payload
        }
    },
    downloadW8W9RequestPDF: (payload) => {
        return {
            type: "DOWNLOAD_W8_W9_PDF",
            payload
        }
    },

    bulkInactivate: (payload) => {
        return {
            type: "BULK_INACTIVATE",
            payload
        }
    },

    bulkReactivate: (payload) => {
        return {
            type: "BULK_REACTIVATE",
            payload
        }
    },

    blockTinRequest: (payload) => {
        return {
            type: 'BLOCK_TIN_REQUEST',
            payload
        }
    },

    unBlockTinRequest: (payload) => {
        return {
            type: 'UN_BLOCK_TIN_REQUEST',
            payload
        }
    },

    updateRecipientEmail: (payload) => {
        return {
            type: "EDIT_RECIPIENT",
            payload
        }
    }

}

function* getPaginatedRecipientListAsync(action) {

    try {
        yield put(setLoadingState({ state: RECIPIENT_LISTING_LOADING_STATES.FETCHING_RECIPIENT_LIST_LOADING }))

        const { PageNumber, PageSize, FilterText, IsDesc, IdNumber, IsActive, IsTinRequested, IsW8request, IsW9Request, TinStartDate, TinEndDate, emailid, TINStatus, TINMatch, selectedPayer, selectedRecipients, highlightedRecipient } = action.payload;

        const params = {
            PayerId: selectedPayer?.PayerDetailId,
            PageNumber: PageNumber || 1,
            PageSize: PageSize || 10,
            FilterText: FilterText || "",
            IdNumber: IdNumber || "",
            IsDesc: IsDesc || false,
            IsActive: IsActive?.value,
            IsTinRequested: IsTinRequested?.value,
            IsW8request,
            IsW9Request,
            TinStartDate,
            TinEndDate,
            Email: emailid,
            TINStatus: TINStatus?.label || "",
            IsUSPSValid: false,
        }

        const response = yield RecipientDataService.getPaginatedRecipientList(params);

        const { Message, Status } = response?.data;
        const Data =  General.extractDataFromResponseData(response?.data)

        if (Status) {
            yield put(setRecipientList(Data));

            const mergedArray = selectedRecipients.map((elementA) => {
                const foundElement = Data.find((elementB) => elementB.RecipentDetailId === elementA.RecipentDetailId);
                return foundElement ? foundElement : elementA;
            });

            let updatedHighlightedRecipient = null;
            if (highlightedRecipient && Object.keys(highlightedRecipient).length !== 0) {
                updatedHighlightedRecipient = Data.find(item => item.RecipentDetailId === highlightedRecipient.RecipentDetailId)
            }
            yield put(setHighlightedRecipient(updatedHighlightedRecipient ?? Data[0]))

            yield put(setSelectedRecipients(mergedArray));

            yield put(setPaginationState({ ...action.payload, totalRecipients: General.extractPaginationTotalFromResponse(response.data) }))


        } else {
            yield put(addNotifications({ heading: "Failed to get the recipients list" }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get the recipients list", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: RECIPIENT_LISTING_LOADING_STATES.FETCHING_RECIPIENT_LIST_READY }))
    }

}

function* deleteRecipientAsync(action) {

    try {
        yield put(setLoadingState({ state: RECIPIENT_LISTING_LOADING_STATES.DELETE_RECIPIENT_LOADING }));

        const { selectedRecipients, highlightedRecipient: { RecipentDetailId }, selectedPayer, isAllSelect = false } = action.payload;

        const recipientIDs = [];

        if (selectedRecipients.length) {
            selectedRecipients.forEach(recipient => {
                recipientIDs.push(recipient?.RecipentDetailId)
            })
        } else {
            recipientIDs.push(RecipentDetailId);
        }

        const response = yield RecipientDataService.deleteRecipient({ RecipientIds: recipientIDs, PayerId: selectedPayer.PayerDetailId, IsAllSelect: isAllSelect });

        const { Message, Status, Data } = response?.data;

        if (Status) {
            let message = Data.SuccessCount == 0 ? "You can not delete this Recipient  because forms are attached with this Recipient." : "";
            let headingText = Data.SuccessCount == 0 ? "Recipients Not Deleted" : "";
            let variant = Data.SuccessCount == 0 ? TOASTER_VARIANT.WARNING : ""

            message = Data.FailureCount > 0 && Data.SuccessCount > 0 ? "Some of Recipients deleted successfully. Some might have forms created under them." : message;
            headingText = Data.FailureCount > 0 && Data.SuccessCount > 0 ? "Some Recipients Deleted" : headingText;
            variant = Data.FailureCount > 0 && Data.SuccessCount > 0 ? TOASTER_VARIANT.SUCCESS : variant


            message = Data.FailureCount == 0 ? "Recipients deleted successfully." : message;
            headingText = Data.FailureCount == 0 ? "Recipients Deleted" : headingText;
            variant = Data.FailureCount == 0 ? TOASTER_VARIANT.SUCCESS : variant

            yield put(setSelectedRecipients([]));
            yield put(setShouldReloadPaginatedRecipientList(true));
            yield put(addNotifications({ heading: headingText, variant: variant, message: message }));
        } else {
            yield put(addNotifications({ heading: "Failed to delete recipients" }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to delete recipients" }));
    } finally {
        yield put(setLoadingState({ state: RECIPIENT_LISTING_LOADING_STATES.DELETE_RECIPIENT_READY }));
        yield put(setDeleteRecipientConfirmationModalOpen(false));
    }

}

function* bulkAddressMatchAsync(action) {

    const { selectedPayer, selectedRecipients } = action.payload;

    try {
        yield put(setLoadingState({ state: RECIPIENT_LISTING_LOADING_STATES.BULK_ADDRESS_MATCH_LOADING }))

        const selectedRecipientIDs = selectedRecipients.map(rec => rec?.RecipentDetailId)
        const response = yield RecipientDataService.processBulkAddressValidation({ PayerId: selectedPayer?.PayerDetailId, RecipientIds: selectedRecipientIDs });

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(setShouldReloadPaginatedRecipientList(true));
            yield put(addNotifications({ heading: Message, message: "Validation complete", variant: TOASTER_VARIANT.SUCCESS }));
            yield put(setBulkAddressMatchModalOpen(false))
        } else {
            yield put(addNotifications({ heading: "Failed to process the data", message: Message }));
        }


    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to process the data", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: RECIPIENT_LISTING_LOADING_STATES.BULK_ADDRESS_MATCH_READY }));
        yield put(setBulkAddressMatchModalOpen(false));
    }
}

function* downloadW8W9RequestPDFAsync({ payload }) {

    try {
        yield put(setLoadingState({ state: RECIPIENT_LISTING_LOADING_STATES.W8_W9_DOWNLOAD_PDF_LOADING }));

        const { RecipentDetailId, requestType, W8FormType, FormW9Id } = payload;
        let response;

        if (requestType === "W8-PDF") {
            response = yield RecipientDataService.downloadW8PDF({ RecipientId: RecipentDetailId, FormName: W8FormType })
        } else if (requestType === "W9-PDF") {
            response = yield RecipientDataService.downloadW9PDF({ FormID: FormW9Id })
        } else {
            yield put(addNotifications({ heading: "Invalid Request Type", message: "Request type must be either W8-PDF or W9-PDF" }));
            return;
        }

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.downloadFileFromBase64(Data.Base64, Data.Name);
        } else {
            yield put(addNotifications({ heading: "Failed to generate the pdf", message: Message }));
        }
    }
    catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to generate the pdf", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: RECIPIENT_LISTING_LOADING_STATES.W8_W9_DOWNLOAD_PDF_READY }))
    }
}

function* bulkInactivateAsync(action) {

    const { PayerID, RecipientIds, selectAll } = action.payload;

    try {
        yield put(setLoadingState({ state: RECIPIENT_LISTING_LOADING_STATES.BULK_INACTIVATE_LOADING }))

        const response = yield RecipientDataService.bulkInactivate({ PayerId: PayerID, RecipientIds, IsAllSelect: selectAll });

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(setShouldReloadPaginatedRecipientList(true));
            yield put(setBulkInActivateModalOpen(false));
            yield put(setSingleActivateReactivateModal(false));
            yield put(addNotifications({ heading: Message, message: "Recipients Inactivate completed", variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(addNotifications({ heading: "Failed to process the data", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to process the data", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: RECIPIENT_LISTING_LOADING_STATES.BULK_INACTIVATE_READY }))
    }
}

function* bulkReactivateAsync(action) {

    const { PayerID, RecipientIds, selectAll } = action.payload;

    try {
        yield put(setLoadingState({ state: RECIPIENT_LISTING_LOADING_STATES.BULK_REACTIVATE_LOADING }))

        const response = yield RecipientDataService.bulkReactivate({ PayerId: PayerID, RecipientIds, IsAllSelect: selectAll });

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(setShouldReloadPaginatedRecipientList(true));
            yield put(setBulkReActivateModalOpen(false));
            yield put(setSingleActivateReactivateModal(false));
            yield put(addNotifications({ heading: Message, message: "Recipients Reactivate completed", variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(addNotifications({ heading: "Failed to process the data", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to process the data", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: RECIPIENT_LISTING_LOADING_STATES.BULK_REACTIVATE_READY }))
    }
}


function* blockTinRequestAsync(action) {

    const recipentDetailId = action.payload.RecipentDetailId

    try {
        yield put(setLoadingState({ state: RECIPIENT_LISTING_LOADING_STATES.BLOCK_TIN_MATCH_LOADING }))

        const response = yield RecipientDataService.blockTinMatch(recipentDetailId);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(setShouldReloadPaginatedRecipientList(true));
            yield put(setBulkReActivateModalOpen(false));
            yield put(setSingleActivateReactivateModal(false));
            yield put(addNotifications({ heading: Message, message: "Recipient's TIN Match Blocked Successfully", variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(addNotifications({ heading: "Failed to process the data", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Unable to Block TIN", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: RECIPIENT_LISTING_LOADING_STATES.BLOCK_TIN_MATCH_READY }))
    }
}

function* unBlockTinRequestAsync(action) {

    const recipentDetailId = action.payload.RecipentDetailId

    try {
        yield put(setLoadingState({ state: RECIPIENT_LISTING_LOADING_STATES.UNBLOCK_TIN_MATCH_LOADING }))

        const response = yield RecipientDataService.unBlockTinMatch(recipentDetailId);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(setShouldReloadPaginatedRecipientList(true));
            yield put(setBulkReActivateModalOpen(false));
            yield put(setSingleActivateReactivateModal(false));
            yield put(addNotifications({ heading: Message, message: "Recipient's TIN Match Unblocked Successfully", variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(addNotifications({ heading: "Failed to process the data", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Unable to Unblock TIN", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: RECIPIENT_LISTING_LOADING_STATES.UNBLOCK_TIN_MATCH_READY }))
    }
}

function* updateRecipientEmailAsync(action) {
    try {
        yield put(setLoadingState({ state: RECIPIENT_LISTING_LOADING_STATES.UPDATE_RECIPIENT_EMAIL_LOADING }))

        const data = action.payload

        const response = yield RecipientDataService.UpdateEmail(data);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(addNotifications({ heading:"Success", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
            yield put(setIsUpdateEmailSuccess(true));
        } else {
            yield put(addNotifications({ heading: "Unable to Updated Recipient", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Unable to Updated Recipient", message: error?.response?.data?.Message }));
        yield put(setIsUpdateEmailSuccess(false));
    } finally {
        yield put(setLoadingState({ state: RECIPIENT_LISTING_LOADING_STATES.UPDATE_RECIPIENT_EMAIL_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getPaginatedRecipientsList().type, getPaginatedRecipientListAsync),
        takeLatest(deleteRecipient().type, deleteRecipientAsync),
        takeLatest(bulkAddressMatch().type, bulkAddressMatchAsync),
        takeLatest(downloadW8W9RequestPDF().type, downloadW8W9RequestPDFAsync),
        takeLatest(bulkInactivate().type, bulkInactivateAsync),
        takeLatest(bulkReactivate().type, bulkReactivateAsync),
        takeLatest(blockTinRequest().type, blockTinRequestAsync),
        takeLatest(unBlockTinRequest().type, unBlockTinRequestAsync),
        takeLatest(updateRecipientEmail().type, updateRecipientEmailAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);